<template>
    <div class="dashboard-employee-card-background">
        <b-button class="dashboard-employee-card-button-style" v-b-toggle.accordion-unassigned-trajectories>
            <div class="float-right">
                <span class="mr-2 badge badge-secondary">{{ trajectoryDataCount }}</span>
                <i v-if="this.open" class="fa fa-chevron-right" aria-hidden="true"></i>
                <i v-else class="fa fa-chevron-down" aria-hidden="true"></i>
            </div>
            {{ uLang('app.unassigned_trajectories') }}
        </b-button>

        <b-collapse class="dashboard-employee-card-collapse" id="accordion-unassigned-trajectories">
            <rea-loader :loading="loading"></rea-loader>
            <table class="unassigned-trajectories-table table mt-4">
                <tr v-if="trajectoryData.length === 0">
                    <td colspan="4">{{ uLang('app.empty_table') }}</td>
                </tr>
                <tr v-if="trajectoryData.length > 0">
                    <th>{{ uLang('app.customer') }}</th>
                    <th>{{ uLang('app.trajectory') }}</th>
                    <th>{{ uLang('app.start_date') }}</th>
                </tr>
                <tr v-for="trajectoryEnrolment in trajectoryData">
                    <td>
                        <router-link
                            :to="relationLink(trajectoryEnrolment)"
                            v-text="trajectoryEnrolment.relation.full_name"
                            target="_blank"
                        />
                    </td>
                    <td>
                        <router-link
                            :to="trajectoryEnrolmentLink(trajectoryEnrolment)"
                            v-text="$getIfExists(trajectoryEnrolment, ['trajectory', 'name'])"
                            target="_blank"
                        />
                    </td>
                    <td>
                        {{ $getIfExists(trajectoryEnrolment, ['trajectory_start_date']) | date }}
                    </td>
                </tr>
            </table>
        </b-collapse>
    </div>
</template>
<script>
    import { ReaLoader } from '~/components/helpers'

    export default {
        name: 'AssignableTrajectories',

        components: {
            ReaLoader
        },

        data() {
            return {
                trajectoryData: [],
                loading: true,
                open: false,
                trajectoryDataCount: 0,
            }
        },

        async created() {
            this.$root.$on('collapse::toggle', async (target, show) => {
                if (target == 'accordion-unassigned-trajectories') {
                    this.open = !this.open;
                }
            });
            this.$root.$on('collapse::toggle::state', async (target, show) => {
                if (target == 'accordion-unassigned-trajectories') {
                    if (show == true && this.loading == true) {
                        const { data } = await window.axios.get(route("dashboard.assignable-trajectories"));
                        this.trajectoryData = data.trajectory_administrator.assignable_trajectories;
                        this.loading = false;
                    }
                }
            });

            const { data } = await window.axios.get(route("dashboard.assignable-trajectories.count"));
            this.trajectoryDataCount = data.assignable_trajectories_count.count;
        },

        methods: {
            relationLink(trajectoryEnrolment) {
                return {
                    name: 'admin.relations.view',
                    params: {
                        'id': trajectoryEnrolment.relation.id,
                    }
                }
            },
            trajectoryEnrolmentLink(trajectoryEnrolment) {
                return {
                    name: 'admin.relations.trajectory-enrolments.edit',
                    params: {
                        'relationId': trajectoryEnrolment.relation.id,
                        'id': trajectoryEnrolment.id,
                    }
                }
            }
        }
    }
</script>
<style lang="scss">
    table.unassigned-trajectories-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }
</style>
